// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"144":"710c13d4","215":"d81260ef"}[chunkId] + ".chunk.js";
};